import { css } from "styled-components"
import { colors } from "../../helpers/colors"
import { BreakPoints, media } from "../../helpers/rwd"
import { fonts } from "../../helpers/fonts"

export const FooterWrapperStyles = css`
  background: ${colors.purple};
`

export const FooterInnerStyles = css``

export const LegalStyles = css`
  font-size: ${fonts.sizes.xs};
  line-height: 20px;
  padding-top: 43px;
  margin-top: 43px;
  border-top: 1px solid ${colors.purpleDark};
  color: ${colors.white};

  ${media.max(BreakPoints.tablet)} {
    padding-top: 13px;
    margin-top: 13px;
  }
`

export const LinksStyles = css`
  display: flex;
  ${media.max(BreakPoints.tablet)} {
    flex-direction: column;
    text-align: inherit;
  }
`

export const StyledLinkStyles = css`
  border-left: 1px solid ${colors.gray};
  color: ${colors.white};
  text-transform: uppercase;
  font-size: ${fonts.sizes.xs};
  text-decoration: none;
  &:first-child {
    border-left: none;
    padding-left: 0;
  }
  &:hover {
    color: ${colors.white};
  }

  ${media.max(BreakPoints.tablet)} {
    border-left: none;
    padding: 5px 0;
  }
`
export const SocialIconStyles = css`
  width: 45px;
  height: 45px;
`

export const LogoWrapperStyles = css`
  max-height: 60px;
  padding: 0;
  border-left: 1px solid ${colors.gray};
  &:first-child {
    border-left: none;
    padding-left: 0;
  }
  ${media.max(BreakPoints.phone)} {
    border-left: none;
  }
`
export const SocialWrapperStyles = css`
  margin-bottom: 41px;
  width: 100%;
  ${media.max(BreakPoints.tablet)} {
    justify-content: center;
    flex-wrap: wrap;
  }
`

export const LogoImgStyle = {
  objectFit: "contain",
  height: "60px",
}
export const LogoStyle = {}
